// @flow
import React from 'react';
import type { Node } from 'react';
import { Trans } from '@lingui/react';

import { FORM_ERROR_CLASSNAME } from '@rover/react-lib/constants';
import { isTranslatable } from '@rover/utilities/i18n';

import Alert from '../Alert';

import type { Props } from './SuccessOrErrorAlert.types';
import { defaultProps } from './SuccessOrErrorAlert.common';

const SuccessOrErrorAlert = ({ error, success, ...other }: Props): Node => {
  const message = error || success;
  const severity = error ? Alert.Severity.DANGER : Alert.Severity.SUCCESS;

  return (
    <Alert severity={severity} className={error ? FORM_ERROR_CLASSNAME : ''} {...other}>
      {isTranslatable(message) ? <Trans id={message} /> : message}
    </Alert>
  );
};

SuccessOrErrorAlert.defaultProps = defaultProps;

export type { Props };
export { defaultProps };
export default SuccessOrErrorAlert;



// WEBPACK FOOTER //
// ../react-lib/src/components/notifications/SuccessOrErrorAlert/SuccessOrErrorAlert.jsx